<template>
  <div class="Instructionsfor">
    <!-- <div class="box">
      </div> -->
    <div class="box">
      <h5 class="isintroduced">操作视频</h5>
      <video
        v-if="itemsa.rjxz.rjsp !== ''"
        :src="http + itemsa.rjxz.rjsp"
        controls="controls"
        class="videosss"
      ></video>
      <h5 class="isintroduced">操作介绍</h5>
      <iframe
        v-if="itemsa.rjxz.rjsm !== ''"
        id="pdfPlayer"
        :src="http + itemsa.rjxz.rjsm"
        frameborder="0"
        width="100%"
        height="1000px"
      ></iframe>
    </div>
  </div>
</template>
<script>
// import pdf from 'vue-pdf'
// import Bus from '@/utils/bus'
export default {
  data() {
    return {
      pageNum: 1,
      pageTotalNum: 1,
      loadedRatio: 0,
      http: this.$store.state.https,
      itemsa: {
        gm: "",
        id: "",
        itemtime: "",
        jg: "",
        jsjs: "",
        kcjs: "",
        ll: "",
        name: "",
        pf: "",
        plcyrs: "",
        plts: "",
        rjxz: {
          bhrjbb: [],
          id: "",
          rjjj: "",
          rjlb: "",
          rjmc: "",
          rjsm: "",
          rjsm1: "",
          rjsp: "",
          rjsp1: "",
          rjtb: "",
          rjtb1: "",
          softwaretime: "",
        },
        sc: "",
        scrq: "",
        softwareid: "",
        sort: "",
        sp: "",
        sp1: "",
        status: "",
        tsy: "",
        userid: "",
        xj: "",
      },
    };
  },
  created() {
    this.selitemid();
  },
  mounted() {
    // Bus.$emit('activeIndexss', '/Instructionsfor')
  },
  methods: {
    // 上一页
    prePage() {
      let page = this.pageNum;
      page = page > 1 ? page - 1 : this.pageTotalNum;
      this.pageNum = page;
    },

    // 下一页
    nextPage() {
      let page = this.pageNum;
      page = page < this.pageTotalNum ? page + 1 : 1;
      this.pageNum = page;
    },
    // 相关课程
    selitemid() {
      var a = sessionStorage.itemss;
      this.itemsa = JSON.parse(a);
    },
  },
  components: {
    // pdf
  },
};
</script>
<style scoped lang="scss">
.Instructionsfor {
  width: 100%;
  .box {
    margin: 0 auto;
    width: 687px;
  }
}
.isintroduced {
  margin-top: 25px;
  margin-bottom: 19px;
  // width: 56px;
  text-align: left;
  padding-left: 10px;
  border-left: 2px solid #4ccaff;
  font-size: 14px;
  font-family: Source Han Sans CN;
  font-weight: bold;
  color: #333333;
}
.videosss {
  margin-left: 11px;
  width: 673px;
  height: 377px;
}
// 适配手机端
@media (max-width: 768px) {
  .Instructionsfor {
    width: 100%;
    .box {
      margin: auto;
      width: 95vw;
    }
  }
  .isintroduced {
    margin-top: 25px;
    margin-bottom: 19px;
    // width: 56px;
    text-align: left;
    padding-left: 10px;
    border-left: 2px solid #4ccaff;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: bold;
    color: #333333;
  }
  .videosss {
    margin-left: 11px;
    width: 95vw;
    height: 377px;
  }
}
</style>
